// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"22d517f6","453":"e8e05591","605":"8f7baf39","641":"d40dddc7","971":"eb2d7ae4"}[chunkId] + ".chunk.js";
};